// Sentry initialization for error tracking
(function() {
  // Load Sentry from CDN
  const script = document.createElement('script');
  script.src = 'https://browser.sentry-cdn.com/7.119.0/bundle.min.js';
  script.integrity = 'sha384-N/+t7zuoySxu9rbUlySpn5qv9w/rBT0D7HE35N2dXNy/1W68iV8i6hc13TPJnKOB';
  script.crossOrigin = 'anonymous';
  
  script.onload = function() {
    if (window.Sentry) {
      Sentry.init({
        dsn: "https://ded8b11bb92d69b184b8ce7409af0108@o4510189822803968.ingest.us.sentry.io/4510189827325952",
        // Setting this option to true will send default PII data to Sentry.
        // For example, automatic IP address collection on events
        sendDefaultPii: true,
        // Set sample rate for performance monitoring
        tracesSampleRate: 1.0,
        // Set the environment
        environment: window.location.hostname.includes('myshopify.com') ? 'development' : 'production',
        // Keep production alerts focused on theme code. These signatures are
        // emitted by Shopify app extensions or embedded mobile-browser bridges
        // and cannot be fixed by the storefront JavaScript.
        ignoreErrors: [
          /^Can't find variable: _AutofillCallbackHandler$/,
          /^Error invoking postMessage: Java object is gone$/,
          /^Error invoking postMessage: Java exception was raised during method invocation$/,
          /^Invalid call to runtime\.sendMessage\(\)\. Tab not found\.$/,
          /^Failed to execute 'registerTool' on 'ModelContext': Access to the feature "tools" is disallowed by permissions policy\.$/,
          /^Failed to execute 'setItem' on 'Storage': Setting the value of '__kla_viewed_reviewed_items' exceeded the quota\.$/,
          /^undefined is not an object \(evaluating 'window\.webkit\.messageHandlers'\)$/,
          /Failed to execute 'importScripts' on 'WorkerGlobalScope'.*\/web-pixels\/strict\/app\/web-pixel-/,
        ],
        denyUrls: [
          /\/extensions\/[^/]+\/product-labels-and-badges-[^/]+\/assets\/lably/,
          /\/shopifycloud\/storefront\/assets\/shop_events_listener/,
          /\/shopifycloud\/storefront\/assets\/storefront\/(?:load_feature|standard-actions)/,
          /\/shopifycloud\/shop-js\/modules\//,
          /\/shopifycloud\/perf-kit\//,
          /\/cdn\/wpm\//,
          /\/web-pixels@[^/]+\//,
          /\/\/scripts\.clarity\.ms\//,
        ],
        beforeSend: function(event) {
          const exceptions =
            event && event.exception && event.exception.values
              ? event.exception.values
              : [];
          const isGenericLoadFailure = exceptions.some(function(exception) {
            return exception && exception.value === 'Load failed';
          });
          const breadcrumbs = event && event.breadcrumbs ? event.breadcrumbs : [];
          const isShopifyTelemetryFailure = breadcrumbs.some(function(breadcrumb) {
            const data = breadcrumb && breadcrumb.data;
            return (
              breadcrumb.category === 'fetch' &&
              breadcrumb.level === 'error' &&
              data &&
              typeof data.url === 'string' &&
              data.url.indexOf('https://otlp-http-production.shopifysvc.com/') === 0
            );
          });

          return isGenericLoadFailure && isShopifyTelemetryFailure ? null : event;
        },
        // Add integrations for better error tracking
        integrations: [
          new Sentry.BrowserTracing(),
          new Sentry.Replay({
            maskAllText: false,
            blockAllMedia: false,
          }),
        ],
        // Session Replay sample rate
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
      });

      console.log('Sentry initialized successfully');
    }
  };
  
  script.onerror = function() {
    console.error('Failed to load Sentry');
  };
  
  document.head.appendChild(script);
})();
